import { useMutation } from "@apollo/client";
import { DeleteAddressDocument } from "@/__generated__/graphql";

export const useDeleteAddressMutation = () => {
  return useMutation(DeleteAddressDocument);
};
